import { gql } from '@apollo/client'

export const SET_USER_DOWNLOAD_APP_MUTATION = gql`
  mutation setUserDownloadApp($appVersion: String, $active: Boolean!) {
    setUserDownloadApp(appVersion: $appVersion, active: $active) {
      success
    }
  }
`

export interface SetUserDownloadAppData {
  setUserDownloadApp: {
    success: string
  }
}
